/*
 * @Author:
 * @LastEditTime: 2024-09-30 16:43:23
 * @Description:
 */
import VisualizationCockpitRouter from './routes'
import 'windi.css'

export default {
  // name version 必须为字面常量
  name: 'visualization-cockpit-sm',
  title: '三维可视化驾驶舱',
  version: '0.0.3',
  description: '三维可视化驾驶舱',
  routes: VisualizationCockpitRouter, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: [
      'SectionApi',
      'FunctionInfoApi',
      'DataCategoryApi',
      'PreferenceSettingApi',
      'ModelSceneApi',
      'huizhou2',
      'MeasuringPointApi',
      'haiguang',
    ],
  },
  config: {},
  /**
   * init: async (store, router, config) {}
   * 异步初始化函数原型
   */
}
